import { Component } from "@angular/core";
import { AuthService } from "../_services/auth.service";
import { Router, Params } from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-page-login",
    templateUrl: "login.component.html",
    styleUrls: ["login.component.scss"],
    imports: [MatButton]
})
export class LoginComponent {

  loginForm: UntypedFormGroup;
  errorMessage = "";

  constructor(
    public authService: AuthService,
    private router: Router,
    private fb: UntypedFormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.loginForm = this.fb.group({
      email: ["", Validators.required ],
      password: ["", Validators.required]
    });
  }

  // tryFacebookLogin() {
  //   this.authService.doFacebookLogin()
  //   .then(res => {
  //     this.router.navigate(["/user"]);
  //   });
  // }

  tryTwitterLogin() {
    this.authService.doTwitterLogin()
    .then(res => {
      this.router.navigate(["/user"]);
    });
  }

  tryGoogleLogin() {
    this.authService.doGoogleLogin()
    .then(res => {
      this.router.navigate(["/user"]);
    });
  }

  tryLogin(value) {
    this.authService.doLogin(value)
    .then(res => {
      this.router.navigate(["/user"]);
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
    });
  }
}
